import * as React from "react";
import { Property } from "types";
import { matchSearchTerm, propertySearchModel } from "utils";

const usePropertySearch = (properties: Property[]) => {
  const [filteredProperties, setFilteredProperties] =
    React.useState(properties);

  const handleSearch = React.useCallback(
    (value: string) => {
      const searchTerm = value ? value.toLowerCase().trim() : "";
      const result = searchTerm
        ? matchSearchTerm(searchTerm, properties, propertySearchModel)
        : [...properties];
      setFilteredProperties(result);
    },
    [properties]
  );

  return [filteredProperties, handleSearch] as [
    Property[],
    (searchTerm: string) => void
  ];
};

export { usePropertySearch };
